module.exports = __webpack_public_path__ + "static/media/daedong-story-03.640a7c89.jpg";